import { render, staticRenderFns } from "./subject-video.vue?vue&type=template&id=3e62996f&scoped=true&"
import script from "./subject-video.vue?vue&type=script&lang=js&"
export * from "./subject-video.vue?vue&type=script&lang=js&"
import style0 from "./subject-video.vue?vue&type=style&index=0&id=3e62996f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e62996f",
  null
  
)

export default component.exports